import { createAPI } from '@/request.js'

// 商家列表
export const list = data => createAPI('/api/merchant/query.mt', 'post', data)

export const merchantNameList = data => createAPI('/api/merchant/query-name.mt', 'post', data)
// 商家详情
export const merchantInfo = data => createAPI('/api/merchant/get.mt', 'post', data)
// 修改商家分润比例
export const profit = data => createAPI('/api/merchant/profit/modify.mt', 'post', data)
// 商家分润比例记录
export const profitList = data => createAPI('/api/merchant/profit/modify/log.mt', 'post', data)
// 修改商家定位
export const position = data => createAPI('/api/merchant/position/modify.mt', 'post', data)
// 修改手机号码
export const cellphone = data => createAPI('/api/merchant/cellphone/modify.mt', 'post', data)
// 手机号码修改记录
export const cellphoneList = data => createAPI('/api/merchant/cellphone/modify/log.mt', 'post', data)
// 修改昵称
export const contactor = data => createAPI('/api/merchant/contactor/modify.mt', 'post', data)
// 调整推广
export const modifyPromote = data => createAPI('/api/merchant/promote/modify.mt', 'post', data)
// 调整旗舰店
export const modifyFlagship = data => createAPI('/api/merchant/flagship/modify.mt', 'post', data)
// 调整店主0元预约
export const modifyBook = data => createAPI('/api/merchant/booking/modify.mt', 'post', data)
// 美团预定
export const modifyMeituanBook = data => createAPI('/api/merchant/booking/modifyMeituanBook.mt', 'post', data)

// 切换美团，抖音分润开关  modifyProfitSwitch
export const modifyProfitSwitch = data => createAPI('/api/merchant/profit/modifySwitch.mt', 'post', data)

// 切换收单机构
export const modifyAcquirer = data => createAPI('/api/merchant/acquirer/modify.mt', 'post', data)

// 调整首页
export const modifyDisplay = data => createAPI('/api/merchant/display/modify.mt', 'post', data)
// 小程序码
export const barcode = data => createAPI('/api/merchant/barcode/get.mt', 'post', data)

// 钱包
export const wallet = data => createAPI('/api/merchant/wallet/get.mt', 'post', data)
// 商家周收益
export const week = data => createAPI('/api/merchant/week/profit.mt', 'post', data)
// 收益明细
export const statement = data => createAPI('/api/merchant/statement/query.mt', 'post', data)
// 明细导出
export const excel = data => createAPI('/download/merchant/statement/excel', 'get', data)
// 商家明细导出
export const excelMerchant = data => createAPI('/download/merchant/excel', 'get', data)
// 解除认证
export const cancelCredit = data => createAPI('/api/merchant/credit/cancel.mt', 'post', data)
// 确认认证
export const confirmCredit = data => createAPI('/api/merchant/credit/confirm.mt', 'post', data)
// 认证记录
export const creditList = data => createAPI('/api/merchant/credit/modify/log.mt', 'post', data)
// 调整提现规则
export const withdraw = data => createAPI('/api/merchant/withdraw/modify.mt', 'post', data)
// 绑定拉卡拉分账账户
export const bindLakalaAccount = data => createAPI('/api/wallet/lakala/bind.mt', 'post', data)
